import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import toast from "react-hot-toast";
import authService from "../services/authService";

export default function AdminLogin() {
  const [login, setLogin] = useState("");
  const [password, setPassword] = useState("");

  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] =
    useState(false);

  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!login.trim() || !password.trim()) {
      toast.error(
        "Please enter email and password"
      );
      return;
    }

    setLoading(true);

    try {
      // =====================================================
      // ADMIN LOGIN
      // =====================================================

      const result =
        await authService.adminLogin({
          login: login.trim(),
          password: password,
        });

      console.log(
        "================================="
      );

      console.log(
        "ADMIN LOGIN SUCCESS"
      );

      console.log(
        "USER:",
        result?.user
      );

      console.log(
        "ROLE:",
        result?.user?.role
      );

      console.log(
        "ROLE SLUG:",
        result?.user?.role?.slug
      );

      console.log(
        "PERMISSIONS:",
        result?.user?.permissions
      );

      console.log(
        "================================="
      );

      const user =
        result?.user;

      if (!user) {
        throw new Error(
          "User information missing"
        );
      }

      // =====================================================
      // SUCCESS MESSAGE
      // =====================================================

      toast.success(
        `Welcome ${user?.role?.name || "Admin"}`
      );

      // =====================================================
      // EVERY VALID ADMIN GOES TO DASHBOARD
      // =====================================================

      navigate(
        "/admin/dashboard",
        {
          replace: true,
        }
      );
    } catch (error) {
      console.error(
        "ADMIN LOGIN ERROR:",
        error
      );

      const message =
        error?.response?.data?.message ||
        error?.message ||
        "Invalid credentials";

      toast.error(message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="container-xxl">
      <div className="authentication-wrapper authentication-basic container-p-y">
        <div className="authentication-inner">

          <div className="card">

            <div className="card-body">

              {/* ================================================= */}
              {/* LOGO */}
              {/* ================================================= */}

              <div className="app-brand justify-content-center mb-3">

                <Link
                  to="/"
                  className="app-brand-link gap-2"
                >

                  <img
                    src="/vitauralogo.jpg"
                    alt="Vitaura Logo"
                    style={{
                      width: "220px",
                      height: "80px",
                      objectFit: "contain",
                      display: "block",
                      margin: "0 auto",
                    }}
                  />

                </Link>

              </div>

              {/* ================================================= */}
              {/* TITLE */}
              {/* ================================================= */}

              <h4 className="mb-4 text-center">
                Admin Panel 👋
              </h4>

              <p className="mb-4 text-center">
                Please sign-in to your admin account
              </p>

              {/* ================================================= */}
              {/* LOGIN FORM */}
              {/* ================================================= */}

              <form
                onSubmit={handleSubmit}
                className="mb-3"
              >

                {/* EMAIL */}

                <div className="mb-3">

                  <label className="form-label">
                    Email
                  </label>

                  <input
                    type="email"
                    value={login}
                    onChange={(e) =>
                      setLogin(e.target.value)
                    }
                    className="form-control"
                    placeholder="Enter email"
                    autoComplete="username"
                    required
                  />

                </div>

                {/* PASSWORD */}

                <div className="mb-3">

                  <div className="d-flex justify-content-between">

                    <label className="form-label">
                      Password
                    </label>

                    <Link to="/forgot-password">
                      <small>
                        Forgot Password?
                      </small>
                    </Link>

                  </div>

                  <div className="input-group">

                    <input
                      type={
                        showPassword
                          ? "text"
                          : "password"
                      }
                      value={password}
                      onChange={(e) =>
                        setPassword(
                          e.target.value
                        )
                      }
                      className="form-control"
                      placeholder="••••••••"
                      autoComplete="current-password"
                      required
                    />

                    <span
                      className="input-group-text cursor-pointer"
                      onClick={() =>
                        setShowPassword(
                          (prev) => !prev
                        )
                      }
                    >

                      <i
                        className={
                          showPassword
                            ? "bx bx-show"
                            : "bx bx-hide"
                        }
                      />

                    </span>

                  </div>

                </div>

                {/* ================================================= */}
                {/* LOGIN BUTTON */}
                {/* ================================================= */}

                <button
                  type="submit"
                  className="btn btn-primary d-grid w-100"
                  disabled={loading}
                >

                  {loading
                    ? "Signing in..."
                    : "Admin Sign in"}

                </button>

              </form>

              {/* ================================================= */}
              {/* USER LOGIN */}
              {/* ================================================= */}

              <p className="text-center mt-2">
  <Link
    to="/"
    state={{ openLoginOtp: true }}
  >
    Back to User Login
  </Link>
</p>
            </div>

          </div>

        </div>
      </div>
    </div>
  );
}